// extracted by mini-css-extract-plugin
export default {"mobile-menu":"MobileMenu_mobile-menu__mxuGP","active":"MobileMenu_active__RD4AO"};